module.exports = __webpack_public_path__ + "img/tizen-mobile.e66f1d43.webp";